module.exports = __webpack_public_path__ + "img/nao-icon.691055b1.png";